import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Reassign Candidate|Data|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'portal' | 'displayType'> = {
	shared: false,
	htmlAllowed: false,
	portal: 'SP',
	displayType: 'Label',
};

type LocNameStart = 'SPToolsReassignCandidateData';
export type SPToolsReassignCandidateDataLocNames =
	| `${LocNameStart}LabelWinner`
	| `${LocNameStart}LabelLoser`
	| `${LocNameStart}LabelFirstName`
	| `${LocNameStart}LabelLastName`
	| `${LocNameStart}LabelPreferredFirstName`
	| `${LocNameStart}LabelPreferredLastName`
	| `${LocNameStart}LabelEmail`
	| `${LocNameStart}LabelAffiliationName`
	| `${LocNameStart}LabelAffiliationID`
	| `${LocNameStart}LabelAffiliationEmail`
	| `${LocNameStart}LabelCompanyName`;

export const spToolsReassignCandidateDataLocs: LocDefs<SPToolsReassignCandidateDataLocNames> = {
	SPToolsReassignCandidateDataLabelWinner: {
		defaultValue: 'Winning Candidate',
		description: 'Label for the winning candidate',
		displayPath: `${pathStart}Winner`,
		legacyName: 'Core/Tools.ReassignCandidateData.Label.WinningCandidateLabel',
		feature: HubFeature.Core,
		...sharedProperties,
	},
	SPToolsReassignCandidateDataLabelLoser: {
		defaultValue: 'Losing Candidate',
		description: 'Label for the losing candidate',
		displayPath: `${pathStart}Loser`,
		legacyName: 'Core/Tools.ReassignCandidateData.Label.LosingCandidateLabel',
		feature: HubFeature.Core,
		...sharedProperties,
	},
	SPToolsReassignCandidateDataLabelFirstName: {
		defaultValue: 'First Name',
		description: 'Label for the first name',
		displayPath: `${pathStart}First Name`,
		legacyName: 'Core/Tools.ReassignCandidateData.FieldLabel.FirstName',
		feature: HubFeature.Core,
		...sharedProperties,
	},
	SPToolsReassignCandidateDataLabelLastName: {
		defaultValue: 'Last Name',
		description: 'Label for the last name',
		displayPath: `${pathStart}LastName`,
		legacyName: 'Core/Tools.ReassignCandidateData.FieldLabel.LastName',
		feature: HubFeature.Core,
		...sharedProperties,
	},
	SPToolsReassignCandidateDataLabelPreferredFirstName: {
		defaultValue: 'Preferred First Name',
		description: 'Label for the preferred first name',
		displayPath: `${pathStart}Preferred First Name`,
		legacyName:
			'CandidateProfile.PrimaryInformation.PreferredName/Tools.ReassignCandidateData.FieldLabel.PreferredFirstName',
		feature: HubFeature.CandidateProfilePrimaryInformationPreferredName,
		...sharedProperties,
	},
	SPToolsReassignCandidateDataLabelPreferredLastName: {
		defaultValue: 'Preferred Last Name',
		description: 'Label for the preferred last name',
		displayPath: `${pathStart}Preferred Last Name`,
		legacyName:
			'CandidateProfile.PrimaryInformation.PreferredName/Tools.ReassignCandidateData.FieldLabel.PreferredLastName',
		feature: HubFeature.CandidateProfilePrimaryInformationPreferredName,
		...sharedProperties,
	},
	SPToolsReassignCandidateDataLabelEmail: {
		defaultValue: 'Email',
		description: 'Label for the email',
		displayPath: `${pathStart}Email`,
		legacyName: 'Core/Tools.ReassignCandidateData.FieldLabel.Email',
		feature: HubFeature.Core,
		...sharedProperties,
	},
	SPToolsReassignCandidateDataLabelAffiliationName: {
		defaultValue: 'Affiliation Name',
		description: 'Label for the affiliation name',
		displayPath: `${pathStart}Affiliation Name`,
		legacyName:
			'CandidateProfile.PrimaryInformation.Affiliation/Tools.ReassignCandidateData.FieldLabel.AffiliationName',
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
		...sharedProperties,
	},
	SPToolsReassignCandidateDataLabelAffiliationID: {
		defaultValue: 'Affiliation ID',
		description: 'Label for the affiliation ID',
		displayPath: `${pathStart}Affiliation ID`,
		legacyName:
			'CandidateProfile.PrimaryInformation.Affiliation/Tools.ReassignCandidateData.FieldLabel.AffiliationID',
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
		...sharedProperties,
	},
	SPToolsReassignCandidateDataLabelAffiliationEmail: {
		defaultValue: 'Affiliation Email',
		description: 'Label for the affiliation email',
		displayPath: `${pathStart}Affiliation Email`,
		legacyName:
			'CandidateProfile.PrimaryInformation.Affiliation/Tools.ReassignCandidateData.FieldLabel.AffiliationEmail',
		feature: HubFeature.CandidateProfilePrimaryInformationAffiliation,
		...sharedProperties,
	},
	SPToolsReassignCandidateDataLabelCompanyName: {
		defaultValue: 'Company Name',
		description: 'Label for the company name',
		displayPath: `${pathStart}Company Name`,
		legacyName: 'Core/Tools.ReassignCandidateData.FieldLabel.CompanyName',
		feature: HubFeature.Core,
		...sharedProperties,
	},
};

export type SPToolsReassignCandidateDataLocType = LocMap<SPToolsReassignCandidateDataLocNames>;
